import useIsSaleCountry from "./useIsSaleCountry";

const useIsBR = () => {
  return useIsSaleCountry("br");
};

export default useIsBR;
